import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../store/auth'
import NProgress from '../plugins/nprogress'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    component: () => {
      console.time('Dashboard组件加载')
      return import('../views/Dashboard.vue').finally(() => {
        console.timeEnd('Dashboard组件加载')
      })
    },
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        redirect: '/dashboard/label-info'
      },
      {
        path: 'label-info',
        name: 'LabelManagement',
        component: () => {
          NProgress.start()
          return import('../views/LabelManagement.vue')
            .finally(() => {
              NProgress.done()
            })
        },
        meta: { title: '标签信息维护' }
      },
      {
        path: 'label-data',
        name: 'LabelDataEntry',
        component: () => {
          NProgress.start()
          return import('../components/LabelDataEntry.vue')
            .finally(() => {
              NProgress.done()
            })
        },
        meta: { title: '标贴数据' }
      },
      {
        path: 'label-print',
        name: 'LabelPrint',
        component: () => {
          const startTime = performance.now()
          console.time('LabelPrint组件加载详情')
          return import(
            /* webpackChunkName: "label-print" */
            /* webpackPrefetch: true */
            '../views/LabelPrint.vue'
          ).then(module => {
            const loadTime = performance.now() - startTime
            console.log('LabelPrint组件加载详细信息:', {
              totalTime: loadTime,
              moduleSize: JSON.stringify(module).length,
              dependencies: Object.keys(module),
            })
            console.timeEnd('LabelPrint组件加载详情')
            return module
          }).catch(error => {
            console.error('LabelPrint组件加载失败:', error)
            throw error
          })
        },
        meta: { title: '标签打印' }
      },
      {
        path: 'label-review',
        name: 'LabelReview',
        component: () => {
          NProgress.start()
          return import('../views/LabelReview.vue')
            .finally(() => {
              NProgress.done()
            })
        },
        meta: { title: '标签审核' }
      },
      {
        path: 'bill-management',
        name: 'BillManagement',
        component: () => {
          NProgress.start()
          return import('../views/BillManagement.vue')
            .finally(() => {
              NProgress.done()
            })
        },
        meta: { title: '账单管理' }
      },
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => {
          NProgress.start()
          return import('../views/UserManagement.vue')
            .finally(() => {
              NProgress.done()
            })
        },
        meta: {
          title: '用户管理',
          requiresAdmin: true
        }
      }
    ]
  },
  {
    path: '/address/management',
    name: 'AddressManagement',
    component: () => import('../views/AddressManagement.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  console.time(`路由 ${to.path} 加载耗时`)
  console.log(`🚀 开始加载路由: ${to.path}`)
  
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && authStore.user?.role !== 'admin') {
    ElMessage.error('无权访问该页面')
    next('/dashboard')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

router.afterEach((to) => {
  console.timeEnd(`路由 ${to.path} 加载耗时`)
  console.log(`✅ 路由 ${to.path} 加载完成`)
})

export default router
